module.exports = __webpack_public_path__ + "static/media/AbbVieLogo_Preferred_DarkBlue_on_white.15840793.jpg";